import { useEffect, useRef } from "react";

const MAX_FAVICON_COUNT = 99;
const BADGE_BG = "#e66a25";
const BADGE_TEXT = "#ffffff";

const clampFaviconCount = (count) => {
  const numeric = Number(count);
  if (!Number.isFinite(numeric) || numeric <= 0) return 0;
  return Math.floor(numeric);
};

const formatCount = (count) =>
  count > MAX_FAVICON_COUNT ? `${MAX_FAVICON_COUNT}+` : `${count}`;

const createCountFavicon = (count) => {
  const canvas = document.createElement("canvas");
  canvas.width = 32;
  canvas.height = 32;
  const ctx = canvas.getContext("2d");
  if (!ctx) return null;

  const label = formatCount(count);

  ctx.clearRect(0, 0, 32, 32);
  ctx.fillStyle = BADGE_BG;
  ctx.beginPath();
  ctx.arc(16, 16, 15, 0, Math.PI * 2);
  ctx.fill();

  ctx.fillStyle = BADGE_TEXT;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  // Smaller/lighter text to keep all variants centered inside badge.
  ctx.font = label.length > 2 ? "500 13px Arial" : "500 16px Arial";
  const isOverflowCount = count > MAX_FAVICON_COUNT;
  const textX = isOverflowCount ? 17 : 16;
  const textY = isOverflowCount ? 17 : 18;
  ctx.fillText(label, textX, textY);

  return canvas.toDataURL("image/png");
};

export const useFavicon = (unreadCount, normalFavicon) => {
  const blinkIntervalRef = useRef();
  const generatedFaviconRef = useRef(null);

  useEffect(() => {
    const setFavicon = (iconURL) => {
      let link = document.querySelector("link[rel*='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = iconURL;
    };

    const normalizedCount = clampFaviconCount(unreadCount);

    if (normalizedCount > 0) {
      generatedFaviconRef.current = createCountFavicon(normalizedCount);
      if (generatedFaviconRef.current && normalFavicon) {
        let isAlert = false;
        blinkIntervalRef.current = setInterval(() => {
          isAlert = !isAlert;
          setFavicon(isAlert ? generatedFaviconRef.current : normalFavicon);
        }, 1000);
      } else if (generatedFaviconRef.current) {
        setFavicon(generatedFaviconRef.current);
      } else if (normalFavicon) {
        setFavicon(normalFavicon);
      }
    } else {
      clearInterval(blinkIntervalRef.current);
      setFavicon(normalFavicon);
    }

    return () => {
      clearInterval(blinkIntervalRef.current);
      if (normalFavicon) {
        setFavicon(normalFavicon);
      }
    };
  }, [unreadCount, normalFavicon]);
};
